module.exports = __webpack_public_path__ + "img/meriferm.bf53d9d6.png";